// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAgkS-Wu_jy3zDC5ZhYa7A0X5Ze79gcnnE",
  authDomain: "youthxconnect-ptb.firebaseapp.com",
  projectId: "youthxconnect-ptb",
  storageBucket: "youthxconnect-ptb.firebasestorage.app",
  messagingSenderId: "357488100709",
  appId: "1:357488100709:web:c19e041f2cb45f03234d8c"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };